const frontendAnalyticsTrack = <T>(
  eventName: string,
  eventProperties: T | Record<string, unknown> = {}
) => {
  const props = {
    ...eventProperties,
    product: 'home_and_auto',
  };

  try {
    (window as any).analytics.track(eventName, props);
  } catch (error) {
    window.Raven.captureException(error, {
      extra: {
        eventName,
        eventProperties,
      },
    });
  }
};

export default frontendAnalyticsTrack;
